import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { WarehouseOrganizationInfoStore } from 'modules/warehouse/stores';
import { localStorageHandler } from 'core/services';
import { CloseOutPalletizingForm } from 'modules/order/forms';
import { notificationError } from 'core/utils';
import { action, makeObservable } from 'mobx';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';

class CloseOutPalletizingViewStore extends BaseViewStore {
	form = new CloseOutPalletizingForm({
		onSuccess: async () => {
			await this.closeOutPalletizing();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.warehouseOrganizationInfoStore = new WarehouseOrganizationInfoStore(rootStore);
		this.initialize();
	}

	@action.bound async initialize() {
		this.suspend();
		this.warehouseDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('warehouseId'),
			store: new ApplicationStore(this.rootStore),
			itemTemplate: {
				value: 'id',
				label: 'applicationTitle',
			},
			filterProperties: {
				warehouseOnly: true,
				isOrganizationActive: true,
				useSafeQuantity: false,
			},
		});
		this.resume();
	}

	@action.bound
	async closeOutPalletizing() {
		this.suspend();
		try {
			const response = await this.warehouseOrganizationInfoStore.closeOutPalletizing(
				sourceOfChange.closeOutPalletizing,
				this.form.$('warehouseId').value
			);
			if (response) {
				this.rootStore.notificationStore.success('WAREHOUSEVIEW.CLOSEOUT.PALLETIZING.SUCCESS');
			} else {
				this.rootStore.notificationStore.error('WAREHOUSEVIEW.CLOSEOUT.PALLETIZING.FAILURE');
				localStorageHandler.set('isCloseOutPalletizing', true);
				localStorageHandler.set('closeOutWarehouse', this.warehouseDropdownStore.value);
				this.rootStore.routerStore.goTo('master.app.main.order.closeout.detail');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
		this.modalParams.success();
	}
}

export default CloseOutPalletizingViewStore;
